import { render, staticRenderFns } from "./District.vue?vue&type=template&id=f82c1d1e&scoped=true&"
import script from "./District.vue?vue&type=script&lang=js&"
export * from "./District.vue?vue&type=script&lang=js&"
import style0 from "./District.vue?vue&type=style&index=0&id=f82c1d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82c1d1e",
  null
  
)

export default component.exports